import React from 'react';

type LoaderProps = {
  modal?: boolean,
  message?: string,
}

const LoaderContent = ({message}: LoaderProps) => (
  <div className="p-5 text-center loader-content">
    <div className="loader"></div>
    {message && (<p className="mt-3">{message}</p>)}
  </div>
);

const LoaderModal = ({message}: LoaderProps) => (
  <div className="__modal_container__ d-flex justify-content-center align-items-center">
    <div className="__modal_background__" />
    <div className="__modal_box__ max-w70 max-h80">
      <LoaderContent message={message} />
    </div>
  </div>
)

export const Loader = ({modal, message}: LoaderProps) => {
  return (<>
    {modal ? (<LoaderModal message={message} />) : (<LoaderContent message={message} />)}
  </>);
}
